export const Especializaciones = {
    "E": {
        "P": "Compras",
        "N": "Nacimientos",
        "T": "Transferencias",
        "R": "Destete"
    },
    "S": {
        "V": "Ventas",
        "C": "Consumos",
        "M": "Mortandad",
        "T": "Transferencias",
        "R": "Recategorizaciones"
    },
    "R": {
        "F": "Faltantes",
        "S": "Sobrantes"
    }
}